import { render, staticRenderFns } from "./printyanfabaoxiao.vue?vue&type=template&id=534b1835&scoped=true&"
import script from "./printyanfabaoxiao.vue?vue&type=script&lang=js&"
export * from "./printyanfabaoxiao.vue?vue&type=script&lang=js&"
import style0 from "./printyanfabaoxiao.vue?vue&type=style&index=0&id=534b1835&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b1835",
  null
  
)

export default component.exports